
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';

import ClinicsModule from '@/store/clinics';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class HomePage extends Vue {
    repository = ClinicsModule;

    get filterSettings() {
        return ClinicsModule.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'clinics_create' });
    }

    async updateList() {
        await ClinicsModule.filter.updateFilter();
        await ClinicsModule.getList();
    }

    async resetFilters() {
        await ClinicsModule.clearSort();
        await ClinicsModule.filter.resetFilter();
        await ClinicsModule.getList();
    }
}
